import { styled } from '@mui/material/styles';
import { Box, Typography } from '@mui/material';

export const DetailSection = styled(Box)(({ theme }) => ({
  padding: theme.spacing(2),
}));

export const SectionTitle = styled(Typography)(({ theme }) => ({
  fontWeight: 700,
  fontSize: '1rem',
  color: '#222',
  marginBottom: theme.spacing(2),
}));

export const FeedbackContainer = styled(Box)(({ theme }) => ({
  backgroundColor: '#F9FAFB',
  padding: theme.spacing(2),
  borderRadius: theme.shape.borderRadius,
  marginTop: theme.spacing(1),
}));

export const InfoValue = styled(Typography)(({ theme }) => ({
  fontWeight: 500,
  fontSize: '1rem',
  color: '#333',
}));
